"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ColumnsV3Controller", {
    enumerable: true,
    get: function() {
        return ColumnsV3Controller;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _columnsv3service = require("~/services/v3/columns-v3.service");
const _controllers = require("~/constants/controllers");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let ColumnsV3Controller = class ColumnsV3Controller {
    async columnAdd(context, tableId, body, req) {
        return await this.columnsV3Service.columnAdd(context, {
            tableId,
            column: body,
            req,
            user: req.user
        });
    }
    async columnUpdate(context, columnId, body, req) {
        return await this.columnsV3Service.columnUpdate(context, {
            columnId: columnId,
            column: body,
            req,
            user: req.user
        });
    }
    async columnDelete(context, columnId, req) {
        return await this.columnsV3Service.columnDelete(context, {
            columnId,
            req,
            user: req.user
        });
    }
    async columnGet(context, columnId) {
        return await this.columnsV3Service.columnGet(context, {
            columnId
        });
    }
    constructor(columnsV3Service){
        this.columnsV3Service = columnsV3Service;
    }
};
_ts_decorate([
    (0, _common.Post)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/fields`
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('columnAdd'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.FieldV3Type === "undefined" ? Object : _nocodbsdk.FieldV3Type,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ColumnsV3Controller.prototype, "columnAdd", null);
_ts_decorate([
    (0, _common.Patch)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/fields/:columnId`,
        `${_controllers.PREFIX_APIV3_METABASE}/fields/:columnId`
    ]),
    (0, _extractidsmiddleware.Acl)('columnUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('columnId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.FieldUpdateV3Type === "undefined" ? Object : _nocodbsdk.FieldUpdateV3Type,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ColumnsV3Controller.prototype, "columnUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/fields/:columnId`,
        `${_controllers.PREFIX_APIV3_METABASE}/fields/:columnId`
    ]),
    (0, _extractidsmiddleware.Acl)('columnDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('columnId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ColumnsV3Controller.prototype, "columnDelete", null);
_ts_decorate([
    (0, _common.Get)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/fields/:columnId`,
        `${_controllers.PREFIX_APIV3_METABASE}/fields/:columnId`
    ]),
    (0, _extractidsmiddleware.Acl)('columnGet'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('columnId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], ColumnsV3Controller.prototype, "columnGet", null);
ColumnsV3Controller = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _columnsv3service.ColumnsV3Service === "undefined" ? Object : _columnsv3service.ColumnsV3Service
    ])
], ColumnsV3Controller);
